import { AVATAR_PRESET_IDS, type AvatarPresetId } from '../../storage'
import ModalBackdrop from '../ModalBackdrop'
import ModalHeader from '../ModalHeader'
import { AvatarGlyph } from '../ProfileAvatar'
import './AvatarPickerModal.css'

/** Self-view only: picking here persists server-side via `onSelect` so other
 * players see the new avatar too. */
function AvatarPickerModal({
  avatarPreset,
  onClose,
  onSelect,
}: {
  avatarPreset: AvatarPresetId | null
  onClose: () => void
  onSelect: (preset: AvatarPresetId) => void
}) {
  return (
    <ModalBackdrop onClose={onClose}>
      <div className="profile__avatar-picker">
        <ModalHeader title="Choose your avatar" onClose={onClose} />
        <div className="profile__avatar-picker-grid">
          {AVATAR_PRESET_IDS.map((preset) => (
            <button
              type="button"
              key={preset}
              className={`profile__avatar-picker-option ${
                avatarPreset === preset
                  ? 'profile__avatar-picker-option--selected'
                  : ''
              }`}
              onClick={() => {
                onSelect(preset)
                onClose()
              }}
              aria-pressed={avatarPreset === preset}
            >
              <AvatarGlyph
                preset={preset}
                className="profile__avatar-picker-glyph"
              />
            </button>
          ))}
        </div>
      </div>
    </ModalBackdrop>
  )
}

export default AvatarPickerModal
